// Translation utilities for user-facing content
import { translations } from './translationDictionaries';

export const translatePropertyType = (type, language = 'es') => {
  const langTranslations = translations[language]?.propertyType || translations.es.propertyType;
  return langTranslations[type] || type;
};

export const translateStatus = (status, language = 'es') => {
  const langTranslations = translations[language]?.status || translations.es.status;
  return langTranslations[status] || status;
};

export const translateListingType = (listingType, language = 'es') => {
  const typeMap = {
    'for-sale': 'forSale',
    'for-rent': 'forRent',
    'sold': 'sold',
    'archived': 'archived'
  };
  const key = typeMap[listingType] || listingType;
  const langTranslations = translations[language]?.listingType || translations.es.listingType;
  return langTranslations[key] || listingType;
};
